import React from 'react'
import ProductCard from '../ProductCard'
import ultraone from '../../assets/ultra.png'
import def from "../../assets/def.jpeg"
import machine from "../../assets/machine.jpeg"

    const data = [
        {
            id: 1,
            name: 'Portable Ultrasound Scanner',
            imgSrc: ultraone,
        },
        {
            id: 2,
            name: 'Defibrillator',
            imgSrc: def,
        },
        {
            id: 3,
            name: 'Patient Monitor',
            imgSrc: machine,
        },
    ]

export default function Card1() {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {data.map((item, index) => (
                <ProductCard key={item.id} product={item} index={index} />
            ))}
        </div>
    )
}
